import { Component, OnInit, inject, output } from '@angular/core';
import { take } from 'rxjs';
import { Customer } from 'src/app/common/Customer';
import { InvoiceFilter } from 'src/app/common/InvoiceFilter';
import { InvoiceGroup } from 'src/app/common/InvoiceGroup';
import { AppProfileService } from 'src/app/services/profile.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { KENDO_DATE } from '@progress/kendo-angular-intl';
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns';
import { FormsModule } from '@angular/forms';

import { KENDO_ICONS } from '@progress/kendo-angular-icons';
import { DateRangeFilterComponent } from '../date-range-filter/date-range-filter.component';
import { FilterCardComponent } from '../filter-card/filter-card.component';
import { isDefaultFilter } from 'src/app/common/filter-state';

@Component({
    imports: [FormsModule, KENDO_DROPDOWNS, KENDO_DATE, KENDO_ICONS, DateRangeFilterComponent, FilterCardComponent],
    selector: 'app-invoice-search',
    templateUrl: './invoice-search.component.html'
})
export class InvoiceSearchComponent implements OnInit {
  private invoiceService = inject(InvoiceService);
  private profileService = inject(AppProfileService);

  public isRetailer: boolean = false;
  public defaultItem: Customer = null;
  public defaultInvoiceGroup: InvoiceGroup = {
    id: null,
    groupName: $localize`Alle`,
    creationDate: null,
    customerId: null,
    filterFromDateTime: null,
    filterToDateTime: null,
    invoices: [],
  };
  public invoiceGroupId: string;
  public invoiceGroups: InvoiceGroup[];
  public filter: InvoiceFilter = new InvoiceFilter(null, null, null, null);

  readonly searchCriteria = output<InvoiceFilter>();

  /** What the page opened with — the yardstick for the reset button (#228). */
  private defaults: InvoiceFilter = new InvoiceFilter(null, null, null, null);

  public get isFiltered(): boolean {
    // The dropdown binds its own field, not `filter.invoiceGroupId`, so it is merged in here.
    return !isDefaultFilter({ ...this.filter, invoiceGroupId: this.invoiceGroupId }, this.defaults);
  }

  public resetFilter(): void {
    this.filter = new InvoiceFilter(
      this.defaults.customerNameOrNumber,
      this.defaults.dateFrom,
      this.defaults.dateTo,
      this.defaults.invoiceGroupId
    );
    this.invoiceGroupId = this.defaults.invoiceGroupId;
    this.searchThis();
  }

  searchThis() {
    if (this.isRetailer) {
      this.invoiceService.getSalesInvoiceGroups(null, null).subscribe((r) => {
        this.invoiceGroups = r;
      });
    }

    this.searchCriteria.emit(this.filter);
  }

  ngOnInit(): void {
    this.filter = this.invoiceService.getDefaultFilter();
    this.defaults = { ...this.filter };
    this.profileService.currentProfile$
      .pipe(
        take(1)
      )
      .subscribe(() => {
        this.searchThis();
      });
  }

  public customerChange(_value: string): void {
    this.searchCriteria.emit(this.filter);
  }

  public invoiceGroupChange(_value: InvoiceGroup): void {
    this.searchCriteria.emit(this.filter);
  }

}
